import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseURL, key } from "../util/Config";

import "../assets/css/main.min.css";
import "../assets/css/custom.css";

const T = {
  pageBg: "#33083e",
  text: "#EAF0FF",
  sub: "#9AA3B2",
  border: "rgba(255,255,255,0.08)",
  card: "#3c134e",
  radius: 16,
  shadow: "0 16px 36px rgba(0,0,0,0.35)",
};

const AgencyTarget = () => {
  const { t } = useTranslation();
  const [rates, setRates] = useState({
    baseCoins: 1000000,
    hostUsdPerMillion: 0.6,
    agencyUsdPerMillion: 0.2,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseURL}setting`, { headers: { key } });
        const setting = response.data?.setting || {};
        setRates({
          baseCoins: Number(setting.salaryUsdBaseCoins || 1000000),
          hostUsdPerMillion: Number(setting.salaryHostUsdPerMillion ?? 0.6),
          agencyUsdPerMillion: Number(setting.salaryAgencyUsdPerMillion ?? 0.2),
        });
      } catch (error) {
        console.error("Error fetching USD rates:", error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const examples = [1_000_000, 5_000_000, 10_000_000];
  const hostFor = (coins) => (coins / rates.baseCoins) * rates.hostUsdPerMillion;
  const agencyFor = (coins) => (coins / rates.baseCoins) * rates.agencyUsdPerMillion;

  return (
    <div
      className="page-container"
      style={{
        background: T.pageBg,
        minHeight: "100vh",
        color: T.text,
        paddingBottom: 92,
      }}
    >
      <div className="page">
        <div
          className="main-wrapper"
          style={{ maxWidth: 2000, margin: "auto", padding: "16px" }}
        >
          <h3 style={{ color: T.text, marginBottom: 8 }}>
            {t("agency_target") || "Agency USD Rates"}
          </h3>
          <p style={{ color: T.sub, marginBottom: 20 }}>
            Linear auto-credit: every gift immediately adds USD to host and agency wallets.
            There is no pending salary or tier unlock.
          </p>

          {loading ? (
            <div style={{ color: T.sub }}>Loading…</div>
          ) : (
            <div
              style={{
                background: T.card,
                border: `1px solid ${T.border}`,
                borderRadius: T.radius,
                boxShadow: T.shadow,
                padding: 16,
              }}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 16 }}>
                <div>
                  <div style={{ color: T.sub, fontSize: 12 }}>Base coins</div>
                  <div style={{ fontSize: 20, fontWeight: 700 }}>{rates.baseCoins.toLocaleString()}</div>
                </div>
                <div>
                  <div style={{ color: T.sub, fontSize: 12 }}>Host USD / base</div>
                  <div style={{ fontSize: 20, fontWeight: 700 }}>${rates.hostUsdPerMillion}</div>
                </div>
                <div>
                  <div style={{ color: T.sub, fontSize: 12 }}>Agency USD / base</div>
                  <div style={{ fontSize: 20, fontWeight: 700 }}>${rates.agencyUsdPerMillion}</div>
                </div>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", color: T.text }}>
                <thead>
                  <tr style={{ borderBottom: `1px solid ${T.border}` }}>
                    <th style={{ padding: 10, textAlign: "left" }}>Coins</th>
                    <th style={{ padding: 10, textAlign: "right" }}>Host</th>
                    <th style={{ padding: 10, textAlign: "right" }}>Agency</th>
                  </tr>
                </thead>
                <tbody>
                  {examples.map((coins) => (
                    <tr key={coins} style={{ borderBottom: `1px solid ${T.border}` }}>
                      <td style={{ padding: 10 }}>{coins.toLocaleString()}</td>
                      <td style={{ padding: 10, textAlign: "right", color: "#34D399" }}>
                        ${hostFor(coins).toFixed(2)}
                      </td>
                      <td style={{ padding: 10, textAlign: "right", color: "#60A5FA" }}>
                        ${agencyFor(coins).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgencyTarget;
